import { Either } from 'purify-ts';
import { ConversationsRepositoryFailure } from './failure';
import {
  ContactName,
  Conversation,
  ListConversationsOptions,
  ListMessagesOptions,
  MarkConversationAsReadProps,
  MarkedAsRead,
  Message,
  Paginated,
  SendMessageProps,
  SentMessage,
  UpdateContactNameProps,
} from './types';

export abstract class IConversationsRepository {
  public abstract getConversations(
    options: ListConversationsOptions
  ): Promise<Either<ConversationsRepositoryFailure, Paginated<Conversation>>>;

  public abstract getMessages(
    options: ListMessagesOptions
  ): Promise<Either<ConversationsRepositoryFailure, Paginated<Message>>>;

  public abstract sendMessage(
    props: SendMessageProps
  ): Promise<Either<ConversationsRepositoryFailure, SentMessage>>;

  public abstract markConversationAsRead(
    props: MarkConversationAsReadProps
  ): Promise<Either<ConversationsRepositoryFailure, MarkedAsRead>>;

  public abstract updateContactName(
    props: UpdateContactNameProps
  ): Promise<Either<ConversationsRepositoryFailure, ContactName>>;
}
